export default "__VITE_ASSET__f029c367__"